import {  useEffect, useRef, useState } from "react";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";

import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import WebDesigner, { OpenGlobalImagePicker } from "../WebDesigner";
import { GetBlogAuthors } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";


export default function BlogHeadingRender({
  component,
  screenSize,
  isEditor,
}: WBRenderProps) {

  // if(component.content == editTextPlaceHolder){
  //   component.content = "";
  // }

  const inputRef = useRef<HTMLTextAreaElement>(null);

  const onUpdateTitle = (title:string,undo:boolean = true) => {
    setNodeComponentAttributeValue(component,"blog-title",title);

    // titleInputRef.current.value = title;
    let input = inputRef.current;
    if (!input) return;

    input.style.height = "auto";
    input.style.height = (input.scrollHeight) + "px";
    if(input.parentElement)
      input.parentElement.style.height = (input.scrollHeight) + "px";

    if(undo){
      let wind = window as any;
      wind.saveUndoState&&wind.saveUndoState();
    }
  };
  

  useEffect(() => {

    const observer = new ResizeObserver((entries) => {
      window.requestAnimationFrame(() => {
        onUpdateTitle(getNodeComponentAttributeValue(component,"blog-title"));
      });
    });
    observer.observe(inputRef.current as Element);
    
    onUpdateTitle(getNodeComponentAttributeValue(component,"blog-title"));
    return () => {
      observer.disconnect();
    }
  // eslint-disable-next-line
  }, [component]);


  return (
    <h1
    className="font-bold"
    style={{width:"100%", maxWidth:"var(--page-width)",textShadow:"inherit"}}
    >
      <textarea
      
      className="font-bold"
        id={"blog-heading-input"}
        ref={inputRef}
        rows={1} 
        defaultValue={getNodeComponentAttributeValue(component,"blog-title")}
        placeholder="Post Title..."
        style={{
          height: "auto",
          background: "none",
          fontFamily: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          color: "inherit",
          border: "none",
          width: "100%",
          textAlign: "inherit",
          overflow: "hidden",
          resize: "none",
          textShadow:"inherit"
        }}
        onClick={(e) => { 
          
          
          // store onclick even to external call "click" on the input
          if(inputRef.current){
            let val = (inputRef.current).value;
            onUpdateTitle(val,val!=getNodeComponentAttributeValue(component,"blog-title"));
          }
         
        }}
        onInput={(e) => {
          let val = (e.target as HTMLInputElement).value;
          onUpdateTitle(val);
         
        }}
      />
    </h1>
  );
}

// const missingImage = `https://ab73d4f72ce8e9b15557-0c15488ef873a8828c5cc0dc7308f897.ssl.cf2.rackcdn.com/Websitebuilder/20240916213555.png`;
// // export function RenderBlogImage({component,altTag,src,yPos,isEditor,limitWidth,radius}:{radius:string,limitWidth:boolean, component:LayoutNode,altTag:string,src:string,yPos:string,isEditor:boolean}){

  


// //   const maxWidth = limitWidth?"var(--page-width)":"";

// //   const [overText,setOverText] = useState(false);

// //   if(isEditor){

// //     if(!src){
// //       src = missingImage;
// //     }

// //     return<> 
// //     <style>
// //       {
// //         `
// //         .blog-image-wrapper .blog-image-edit{
// //           opacity:0;
// //           transition: opacity .3s;
        
// //         }

// //         .blog-image-edit:hover{
// //           opacity:1;

// //         }

// //         `

// //       }
// //     </style>
// //     <div className="blog-image-wrapper relative w-full"  style={{maxWidth:maxWidth}}>
// //       <img className="blog-hero-image" src={src} alt={altTag} style={{width:"100%",height:"400px",objectFit:"cover",maxHeight:"400px",objectPosition:`50% ${yPos}`,borderRadius:radius}}/>
      
// //       <div className="center-all w-full h-full blog-image-edit" style={{position:"absolute",left:0,top:0,background:"#ffffffaa",zIndex:(overText?"1":"100"),opacity:(overText?"0":""),cursor:(overText?"text":"default")}}
      
// //       onMouseMove={(e)=>{

// //         let txt = document.getElementById("blog-heading-input");
// //         if(e.target){
// //           let any = (e.target as HTMLElement).tagName;
// //           if(any == "BUTTON"){
// //             setOverText(false);
// //             return;
// //           }
// //         }
// //         if(txt){
// //           let bnds = txt.getBoundingClientRect();

// //           let x = e.clientX;
// //           let y = e.clientY;
// //           if(x>bnds.left&&x<bnds.left+400&&y>bnds.top&&y<bnds.bottom){
// //             setOverText(true);
// //           }else{
// //             setOverText(false);

// //           }
// //         }
// //       }}
      
// //       >
// //         <div className="flex-col col-gap-large">
// //         <button className="w-button w-button-primary block-edit"
// //      style={{width:"200px"}}
// //         onClick={(e)=>{

// //           e.preventDefault();
// //           e.stopPropagation();

// //           OpenGlobalImagePicker((url:string)=>{
// //             setNodeComponentAttributeValue(component,"blog-hero-image",url);
       

// //             setTimeout(()=>{component.forceUpdate&&component.forceUpdate();
// //               let wind = window as any;
// //               wind.saveUndoState&&wind.saveUndoState();
// //             },0); // avoid updating state in render
            

// //           });

// //         }}
        
// //         >{src==missingImage?"Select Hero Image":"Change Hero Image"}</button>
        

// //         </div>
// //         </div>
// //     </div></>
// //   }

// // if(!src)
// //   return null;

// // return  <img src={src} alt={altTag} style={{maxWidth:maxWidth, width:"100%",height:"400px",objectFit:"cover",maxHeight:"400px",objectPosition:`50% ${yPos}`,borderRadius:radius}}/>
// // }

export function RenderBlogEditorOverlay({component,overlayed}:{component:LayoutNode,overlayed:boolean}){

  

  const mainRef = useRef<HTMLDivElement>(null);
  const detailsRef = useRef<any>(null);

  const onMouseMove = (e:React.MouseEvent<HTMLDivElement, MouseEvent>)=>{
    let txt = document.getElementById("blog-heading-input");
    let editBtn = document.getElementById("details-edit-button");
    let img = document.querySelector(".blog-heading-image");
    let postDetails = document.querySelector(".blog-post-details");

    if(img && mainRef.current){
      let bounds = img.getBoundingClientRect();
      mainRef.current.style.height = `${bounds.height}px`; 
      mainRef.current.style.width = `${bounds.width}px`;
      mainRef.current.style.left = `${bounds.left}px`;
      mainRef.current.style.top = `${bounds.top}px`;
      mainRef.current.style.position = "fixed";

    }

    if(postDetails && detailsRef.current){
      let bounds = postDetails.getBoundingClientRect();
      // detailsRef.current.style.height = `${bounds.height}px`; 
      detailsRef.current.style.width = `${bounds.width}px`;
      detailsRef.current.style.left = `${bounds.left}px`;
      detailsRef.current.style.bottom = `${bounds.bottom}px`;
      detailsRef.current.style.position = "fixed";

    }

    if(e.target){
      let any = (e.target as HTMLElement).tagName;
      if(any == "BUTTON"){
        setOverText(false);
        return;
      }
    }
    if(txt){
      let bnds = txt.getBoundingClientRect();

      let x = e.clientX;
      let y = e.clientY;
      if(x>bnds.left&&x<bnds.left+bnds.width&&y>bnds.top&&y<bnds.bottom){
        setOverText(true);
      }
      else if(editBtn){
        let bnds = editBtn.getBoundingClientRect();
        if(x>bnds.left&&x<bnds.left+bnds.width&&y>bnds.top&&y<bnds.bottom){
          setOverText(true);
        }
        else{
          setOverText(false);
        }
      }
      else{
        setOverText(false);

      }
    }

  }

  const [overText,setOverText] = useState(false);
  
    return <> 
    <style>
      {
        `
        .blog-image-wrapper .blog-image-edit{
          opacity:0;
          transition: opacity .3s;
          
        
        }

        .blog-details-wrapper{
        
        position:relative;
        z-index:40;
        }

        .blog-image-edit:hover{
          opacity:1;

        }

        .preview-screen .blog-image-wrapper{
          display:none !important;
        }

        .preview-screen textarea{
          pointer-events:none;
        }

        `

      }
    </style>
    <div className="blog-image-wrapper relative h-full w-full"   onMouseMove={onMouseMove}  style={{position:"absolute",zIndex:(overText?"0":"100"),cursor:(overText?"text":"default")}} >

      <div className="center-all w-full h-full blog-image-edit" ref ={mainRef} style={{position:"absolute",left:0,top:0,background:"#ffffffaa",opacity:(overText?"0":"")}}
      
    
      >
        <div className="flex-col col-gap-large">
        <button className="w-button w-button-primary block-edit"
     style={{width:"200px",marginBottom:(overlayed?"140px":"0")}}
        onClick={(e)=>{

          e.preventDefault();
          e.stopPropagation();

          OpenGlobalImagePicker((url:string)=>{
            setNodeComponentAttributeValue(component,"blog-hero-image",url);
       

            setTimeout(()=>{component.forceUpdate&&component.forceUpdate();
              let wind = window as any;
              wind.saveUndoState&&wind.saveUndoState();
            },0); // avoid updating state in render
            

          });

        }}
        
        >Change Hero Image</button></div></div></div></>
}


export function RenderBlogDetails({isEditor,context,title,author,profileImg,authorId,date,tags,categories,readTime,children}:{isEditor:boolean,context:UserContext,authorId?:string,children?:React.ReactElement, profileImg?:string,title?:string,author?:string,date?:string,tags?:string[],categories?:string[],readTime?:number}){



  const [authorImg,setAuthorImg] = useState(profileImg??"");
  const [authorName,setAuthorName] = useState(author);

  useEffect(()=>{
    GetBlogAuthors(context,(data)=>{

      if(data?.data?.data){
        let authorData = data.data.data.find((author:any)=>author.encUserID == authorId);
        if(authorData){
          if(authorData.photoURL && authorData.photoURL.length>1)
            setAuthorImg(authorData.photoURL);
          else
            setAuthorImg(authorData.spintials)
          setAuthorName(`${authorData.firstName} ${authorData.lastName}`);
        }
        else{
          setAuthorName("Anonymous");
          setAuthorImg("");
        }

      }

     },(data)=>{});


  },[authorId,context]);


    return <div className="flex-column w-full col-gap-med blog-post-details">
                {<style>

                  {isEditor&&`
          .details-edit-button {
            opacity:.2;
            transition:opacity .3s;
            background:#ffffffaa;
            border-radius:50%;

                    width:40px;
                    height:40px;
                    display:flex;
                    justify-content:center;
                    align-items:center;
            padding:6px;
            box-shadow:0 3px 3px 3px #00000022;
      
          }

          .blog-post-details:hover .details-edit-button{
            opacity:1;  
          }

                  
                  `

                  }
            {`
            .blog-chip-row{
              flex-wrap:wrap;
              margin:8px 0;

            }

            .blog-author-text{
            font-weight:500;
            }
            .blog-time-text{
              font-size:.9em;
              color:var(--default-font-color);
              opacity:.8;
              font-weight:400;
            }
            .blog-author-img{
              border-radius:50%;
              border:1px solid var(--default-font-color);
            }
            .blog-chip{
              padding:4px 8px;
              border: 1px solid var(--default-font-color);
              border-radius:8px;
              background:var(--default-font-color);
              color:var(--default-bg-color);
              font-size:.9em;
              opacity:.8;
              font-weight:500;
              text-shadow:none !important;
              }

              .blog-chip.tag{
                background:var(--default-bg-color);
                color:var(--default-font-color);
                }

            `

            }
          </style>

          }
        {children}
        {title&&<><h1 className="font-bold" dangerouslySetInnerHTML={{__html:title}}></h1><br/></>}
        <div className="flex-row row-gap-med align-items-center relative">
 
            {authorImg.length>0&&<div>
              
              <div id='author-profile-img' className="blog-author-img center-all font-large font-bold "  style={{backgroundImage:(authorImg.length>3?`url(${authorImg})`:""),marginRight:"8px",backgroundColor:"#dddddd",color:"#444", height:"60px",width:"60px",backgroundSize:"cover",backgroundPosition:"center"}}  >
                {authorImg.length<3&&authorImg.length>0 && <>{`${authorImg}`}</>}
              </div>
            
            </div>}

            <div className="flex-column blog-text-container">
                {author&& <div id='blog-author-text' className="blog-author-text ">{authorName}</div>}
                {(readTime||date)&&<div className="blog-time-text flex-row row-gap-small">{readTime&&<span className="blog-read-time">{readTime} min read </span>} {readTime&&date&&<span className="blog-time-divider">·</span>}  {date&&<span className="blog-date">{date}</span>}</div>}

              </div>
              {
            isEditor&&<button id='details-edit-button'  className="invisible-button details-edit-button"
            onClick={(e)=>{
              //update title again when opening settings
      

              document.getElementById("manage-post-settings-button")?.click();
            }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 512 512"><path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/></svg>
              </button>

          }
        </div>

        {((categories&&categories.length>0)||(tags&&tags.length>0))&&<div className="blog-chip-row flex-row gap-small">

            {categories&&categories.map((cat,index)=><div key={index} className="blog-chip category">{cat}</div>)}
            {tags&&tags.map((tag,index)=><div key={index} className="blog-chip tag">{tag}</div>)}
        </div>}
      </div>

}